// libs
import { styled } from '@nykaa/ui-components';
import { COLORS } from 'styles/base';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const LoginNudgeContainer = styled.div`
  position: relative;
`;

export const WishlistButton = styled.div`
  width: 24px;
  height: 24px;
  display: flex;

  justify-content: center;
  align-items: center;
`;

export const WishlistIcon = styled.i<{ size: number; isWishlistProduct: boolean }>`
  position: relative;
  font-size: ${(props) => props.size}px;
  color: ${(props) => (props.isWishlistProduct ? COLORS.BRAND_PRIMARY_100 : COLORS.BLACK_92)};
`;
